import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const checkboxTokens = [
  { propertyPath: 'checkedColor', tokenName: '--bg-interactive-control-selected' },
  { propertyPath: 'checkedHoverColor', tokenName: '--bg-interactive-control-selected-hover' },
  { propertyPath: 'disabledColor', tokenName: '--bg-interactive-control-disabled' },
  { propertyPath: 'uncheckedBorderColor', tokenName: '--semantic-border-bold' },
  { propertyPath: 'uncheckedHoverBorderColor', tokenName: '--semantic-border-inverse' },
] satisfies Token[];

export const checkboxTokenMetadata: PaletteTokenMetadata = {
  componentName: 'checkbox',
  tokens: checkboxTokens,
};

export const checkbox = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['checkbox'] => {
  if (!opts.panwRebrandStubYear) {
    return undefined;
  }

  const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
  const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
  return buildPaletteFromMetadata(checkboxTokenMetadata.tokens, tokens, xcorTokens);
};
